import { makeStyles } from 'vendor/material';
import {
  fontWeightMediumLarge,
  fontWeightBold,
} from 'utils/fontWeightConstants';

export const useStyles = makeStyles((theme) => ({
  iconContentWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    flex: 1,
    minWidth: 0,
    '@media (max-width: 600px)': {
      flex: '1 1 auto',
    },
  },
  bannerContainer: {
    width: '100%',
    minHeight: theme.typography.pxToRem(56),
    borderRadius: theme.shape.borderRadius,
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
    backgroundColor: theme.palette.BLUE050,
    boxShadow: theme.depth.d400,
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    '@media (max-width: 600px)': {
      padding: theme.spacing(1.5),
      gap: theme.spacing(0.5),
    },
  },
  infoIcon: {
    width: theme.typography.pxToRem(24),
    height: theme.typography.pxToRem(24),
    color: theme.palette.NEUTRAL600,
    marginRight: theme.spacing(1),
    flexShrink: 0,
    '@media (max-width: 600px)': {
      alignSelf: 'flex-start',
      marginTop: theme.spacing(0.5),
    },
  },
  content: {
    display: 'block',
    flex: '1 1 auto',
    color: theme.palette.NEUTRAL900,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(24),
    fontWeight: fontWeightBold,
    fontFamily: theme.typography.fontFamily,
    '@media (max-width: 600px)': {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(20),
    },
    '& p': {
      margin: 0,
      display: 'inline',
    },
    '& > *': {
      display: 'block',
      whiteSpace: 'pre-wrap',
    },
    '& a': {
      display: 'inline-block',
      verticalAlign: 'baseline',
      color: theme.palette.BLUE400,
    },
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    flexShrink: 0,
    marginRight: theme.spacing(2),
    '@media (max-width: 600px)': {
      width: '100%',
      marginRight: 0,
      marginTop: theme.spacing(1),
      order: 2,
    },
  },
  checkbox: {
    color: theme.palette.NEUTRAL090,
    '& .MuiSvgIcon-root': {
      width: theme.typography.pxToRem(24),
      height: theme.typography.pxToRem(24),
    },
    '& .tackle-checkbox-label': {
      color: theme.palette.NEUTRAL600,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(18),
      fontFamily: theme.typography.fontFamily,
      fontWeight: fontWeightMediumLarge,
      marginLeft: theme.spacing(1),
    },
  },
  closeButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(1),
    '@media (max-width: 600px)': {
      marginLeft: 'auto',
      order: 1,
    },
  },
  closeButton: {
    width: theme.typography.pxToRem(24),
    height: theme.typography.pxToRem(24),
    backgroundColor: theme.palette.BLUE050,
  },
  closeIcon: {
    color: theme.palette.NEUTRAL900,
  },
}));
